import { useKeycloak } from '@react-keycloak/web';
import { useCallback, useEffect, useState } from 'react';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useUser = () => {
  const [user, setUser] = useState(null);
  const { keycloak } = useKeycloak();
  const httpClient = useHttpClient(true);

  const addUserToDb = useCallback(
    async (user) => {
      await httpClient.current?.post(`/api/users`, user);
    },
    [httpClient]
  );

  useEffect(() => {
    const isAuthenticated = keycloak.authenticated;
    const isAdmin = keycloak.hasResourceRole('ROLE_AGRISED_ADMIN') ?? false;
    const isSuperAdmin = keycloak.hasResourceRole('ROLE_AGRISED_ADMIN_SUPER') ?? false;
    const userInfo: any = keycloak.tokenParsed;
    setUser({
      isAuthenticated,
      isAdmin,
      isSuperAdmin,
      id: userInfo.sub,
    });

    const newUser = {
      id: userInfo.sub,
      username: userInfo.preferred_username,
      nom: userInfo.family_name,
      prenom: userInfo.given_name,
      email: userInfo.email,
    };
    addUserToDb(newUser);
  }, [keycloak, addUserToDb]);

  return {
    user,
  };
};
